"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PWSSamplingEventStatus = void 0;
var PWSSamplingEventStatus;
(function (PWSSamplingEventStatus) {
    PWSSamplingEventStatus[PWSSamplingEventStatus["Active"] = 1] = "Active";
    PWSSamplingEventStatus[PWSSamplingEventStatus["Inactive"] = 2] = "Inactive";
    PWSSamplingEventStatus[PWSSamplingEventStatus["Completed"] = 3] = "Completed";
})(PWSSamplingEventStatus = exports.PWSSamplingEventStatus || (exports.PWSSamplingEventStatus = {}));
//# sourceMappingURL=PWSSamplingEventStatus.js.map